import {
  placeBlockWithRules,
  refreshConnectionsAround
} from "../core/blockPlacement.ts";

export function generateVanillaModelShowcase(world) {
  world.beginTransaction("Generate vanilla model showcase");

  try {
    world.runBatch(function () {
      world.fill(-18, 0, -10, 18, 0, 10, "polished_andesite");

      const facings = ["north", "east", "south", "west"];
      facings.forEach(function (facing, index) {
        placeBlockWithRules(
          world,
          { x: -14 + index * 3, y: 1, z: -6 },
          "stone_brick_stairs",
          {
            facing,
            half: "bottom",
            shape: "straight",
            waterlogged: "false"
          }
        );

        placeBlockWithRules(
          world,
          { x: -14 + index * 3, y: 1, z: -3 },
          "stone_brick_stairs",
          {
            facing,
            half: "top",
            shape: "inner_left",
            waterlogged: "false"
          }
        );
      });

      ["bottom", "top", "double"].forEach(function (type, index) {
        placeBlockWithRules(
          world,
          { x: 2 + index * 3, y: 1, z: -6 },
          "stone_brick_slab",
          {
            type,
            waterlogged: "false"
          }
        );
      });

      for (let x = -14; x <= -6; x += 1) {
        placeBlockWithRules(
          world,
          { x, y: 1, z: 2 },
          "spruce_fence",
          {}
        );
      }

      for (let x = -2; x <= 6; x += 1) {
        placeBlockWithRules(
          world,
          { x, y: 1, z: 2 },
          "glass_pane",
          {}
        );
      }

      for (let x = 10; x <= 15; x += 1) {
        placeBlockWithRules(
          world,
          { x, y: 1, z: 2 },
          "stone_brick_wall",
          {}
        );
      }
      placeBlockWithRules(
        world,
        { x: 12, y: 1, z: 3 },
        "stone_brick_wall",
        {}
      );

      placeBlockWithRules(
        world,
        { x: -12, y: 1, z: 7 },
        "spruce_door",
        {
          facing: "south",
          hinge: "left",
          open: "false",
          powered: "false"
        }
      );

      placeBlockWithRules(
        world,
        { x: -8, y: 1, z: 7 },
        "spruce_door",
        {
          facing: "south",
          hinge: "right",
          open: "true",
          powered: "false"
        }
      );

      [
        { x: -2, open: "false", half: "bottom" },
        { x: 1, open: "true", half: "bottom" },
        { x: 4, open: "false", half: "top" }
      ].forEach(function (item) {
        placeBlockWithRules(
          world,
          { x: item.x, y: 2, z: 7 },
          "spruce_trapdoor",
          {
            facing: "south",
            half: item.half,
            open: item.open,
            powered: "false",
            waterlogged: "false"
          }
        );
      });

      world.setBlock(
        9,
        1,
        7,
        "spruce_log",
        { axis: "x" }
      );
      world.setBlock(
        11,
        1,
        7,
        "spruce_log",
        { axis: "y" }
      );
      world.setBlock(
        13,
        1,
        7,
        "spruce_log",
        { axis: "z" }
      );

      world.setBlock(
        16,
        2,
        7,
        "lantern",
        { hanging: "false", waterlogged: "false" }
      );
      world.setBlock(
        16,
        4,
        7,
        "lantern",
        { hanging: "true", waterlogged: "false" }
      );

      refreshConnectionsAround(world, world.entries());
    });

    return world.commitTransaction();
  } catch (error) {
    world.cancelTransaction();
    throw error;
  }
}
